/*

<inventory-location-editor
    [inventory]="InventorySource object instance"
    [warehouseLocations]="string[]"
    (onLocationEntered)="onRestockBinScanned()"
    [disabled]="boolean(false)">
    [allowReuse]="boolean(false)"
    (onReusePiece)="dialogRef.close('reusePiece')"
</inventory-location-selector>

*/
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild, isDevMode } from '@angular/core';
import { InventorySource } from 'src/app/acumatica/EntityServices/OrderPicking.service';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialog } from 'src/app/common/alert-dialog/alert-dialog.component';
import { Sound } from 'src/app/services/audio.service';
import { ScannerManagerService } from 'src/app/directives/scan-input.directive';

@Component({
  selector: 'inventory-location-editor',
  templateUrl: './inventory-location-editor.component.html',
  styleUrls: ['./inventory-location-editor.component.css']
})
export class InventoryLocationEditorComponent {
  @Input() warehouseLocations!: string[];
  @Input() inventory!: InventorySource;
  @Input() allowReuse: boolean = false;
  @Input() disabled: boolean = false;
  @Input() suffixTemplate?: TemplateRef<any>;

  @Output() onLocationEntered = new EventEmitter<string>();
  @Output() onReusePiece = new EventEmitter();

  @ViewChild('RestockLocationField') RestockLocationField?: ElementRef;
  restockLocationIDField: string | null = null;

  onLocationScanned(locationID: string | number | null) {
    if (locationID === null || locationID === '') {
      this.restockLocationIDField = null;
      return;
    }

    locationID = locationID.toString();

    // valid warehouse location?
    let validLocation = this.warehouseLocations.contains(locationID);
    if (!validLocation) {
      this.dialog.open(AlertDialog, {
        data: {
          sound: Sound.ErrorBeep,
          message: "\"" + locationID + "\" is not a valid<br />Warehouse location",
          icon: 'warning',
          buttonText: 'OK'
        }
      }).afterClosed().subscribe(() => {
        this.RestockLocationField!.nativeElement.value = '';
        setTimeout(() => this.RestockLocationField!.nativeElement.focus(), 10);
      });
      return;
    }

    this.inventory.LocationID = locationID;
    this.onLocationEntered.emit(locationID);
  }

  isDevMode = isDevMode();

  constructor(
    private dialog: MatDialog,
    public scanMgr: ScannerManagerService
  ) { }

  public reset() {
    if(this.RestockLocationField?.nativeElement) this.RestockLocationField!.nativeElement.value = null;
    this.focus();
  }

  public focus() {
    this.RestockLocationField?.nativeElement.focus();
  }
}
